/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/* Template custom: api */

import {
  ApiAcceptInvitationDto,
  ApiApplyReferralCodeDto,
  ApiAssistantAuthResponse,
  ApiAssistantEncryptedMessageResponse,
  ApiAssistantLoginChallengeJwtDto,
  ApiAssistantPublicKeyDto,
  ApiAuthResponse,
  ApiCanRequestSystemCodeResponse,
  ApiChangePasswordDto,
  ApiCreateInvitationDto,
  ApiCreateScopeDto,
  ApiCreateSystemCodeRequestDto,
  ApiCurrentUserResponse,
  ApiGoogleVerifyCodeDto,
  ApiGoogleVerifyDto,
  ApiInvitationResponse,
  ApiLegacyTokenDto,
  ApiLoginDto,
  ApiLogoutAllResponse,
  ApiPinOprfEvaluateDto,
  ApiPinOprfEvaluationResponse,
  ApiPinSetupDto,
  ApiPinUnlockDto,
  ApiPinUnlockResponse,
  ApiReferralCodeResponse,
  ApiRefreshResponse,
  ApiRefreshTokenDto,
  ApiRegisterDto,
  ApiRequestEmailVerificationDto,
  ApiRequestPasswordResetDto,
  ApiResetPasswordDto,
  ApiScopeResponse,
  ApiSendReferralCodeEmailDto,
  ApiSetMarketingDto,
  ApiSetPushSettingsDto,
  ApiSuccessResponse,
  ApiSystemCodeRequestResponse,
  ApiTenantProfileResponse,
  ApiUpdateFcmTokenDto,
  ApiUpdateReferralCodeDto,
  ApiUpdateUserDto,
  ApiVerifyEmailByOtpDto,
  ApiVerifyEmailDto,
} from "./data-contracts";
import {
  ApiBaseError,
  ContentType,
  HttpClient,
  RequestParams,
} from "./http-client";

export class GtwAuth<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthLogin
   * @summary Login user with email and password
   * @request POST:/gtw/auth/auth/login
   * @secure
   * @response `200` `ApiAuthResponse` Returns access and refresh tokens after login
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Invalid credentials
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authLogin = (data: ApiLoginDto, params: RequestParams = {}) =>
    this.request<ApiAuthResponse, ApiBaseError>({
      path: `/gtw/auth/auth/login`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthRegister
   * @summary Register new user
   * @request POST:/gtw/auth/auth/register
   * @secure
   * @response `201` `ApiSuccessResponse` Registration successful
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Failed to fetch profile
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authRegister = (data: ApiRegisterDto, params: RequestParams = {}) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/auth/register`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthRefresh
   * @summary Refresh access and refresh tokens
   * @request POST:/gtw/auth/auth/refresh
   * @secure
   * @response `200` `ApiRefreshResponse` Returns new pair of access and refresh tokens
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Invalid session or session expired
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authRefresh = (data: ApiRefreshTokenDto, params: RequestParams = {}) =>
    this.request<ApiRefreshResponse, ApiBaseError>({
      path: `/gtw/auth/auth/refresh`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthChangePassword
   * @summary Change user password
   * @request POST:/gtw/auth/auth/change-password
   * @secure
   * @response `200` `ApiSuccessResponse` Password successfully changed
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Invalid credentials
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authChangePassword = (
    data: ApiChangePasswordDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/auth/change-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthLogout
   * @summary Logout from current session
   * @request POST:/gtw/auth/auth/logout
   * @secure
   * @response `200` `ApiSuccessResponse` Confirms user was logged out
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authLogout = (data: ApiRefreshTokenDto, params: RequestParams = {}) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/auth/logout`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthLogoutAll
   * @summary Logout from all devices
   * @request POST:/gtw/auth/auth/logout-all
   * @secure
   * @response `200` `ApiLogoutAllResponse` Returns the number of terminated sessions
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authLogoutAll = (params: RequestParams = {}) =>
    this.request<ApiLogoutAllResponse, ApiBaseError>({
      path: `/gtw/auth/auth/logout-all`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthRequestEmailVerification
   * @summary Request email verification
   * @request POST:/gtw/auth/auth/request-email-verification
   * @secure
   * @response `200` `ApiSuccessResponse` Verification email sent
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authRequestEmailVerification = (
    data: ApiRequestEmailVerificationDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/auth/request-email-verification`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthVerifyEmailByOtp
   * @summary Verify email using OTP code
   * @request POST:/gtw/auth/auth/verify-email/otp
   * @secure
   * @response `200` `ApiSuccessResponse` Email successfully verified
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authVerifyEmailByOtp = (
    data: ApiVerifyEmailByOtpDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/auth/verify-email/otp`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthVerifyEmail
   * @summary Verify email using confirmation code
   * @request POST:/gtw/auth/auth/verify-email
   * @secure
   * @response `200` `ApiAuthResponse` Email successfully verified
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authVerifyEmail = (data: ApiVerifyEmailDto, params: RequestParams = {}) =>
    this.request<ApiAuthResponse, ApiBaseError>({
      path: `/gtw/auth/auth/verify-email`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthRequestPasswordReset
   * @summary Request password reset by email
   * @request POST:/gtw/auth/auth/request-password-reset
   * @secure
   * @response `200` `ApiSuccessResponse` Reset link or code sent to email
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authRequestPasswordReset = (
    data: ApiRequestPasswordResetDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/auth/request-password-reset`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthResetPassword
   * @summary Reset password using code or token
   * @request POST:/gtw/auth/auth/reset-password
   * @secure
   * @response `200` `ApiSuccessResponse` Password successfully reset
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Invalid or expired password reset token
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authResetPassword = (data: ApiResetPasswordDto, params: RequestParams = {}) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/auth/reset-password`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthLegacy
   * @summary Authenticate using legacy token
   * @request POST:/gtw/auth/auth/legacy
   * @secure
   * @response `200` `ApiAuthResponse` Successfully authenticated
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Invalid legacy token
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authLegacy = (data: ApiLegacyTokenDto, params: RequestParams = {}) =>
    this.request<ApiAuthResponse, ApiBaseError>({
      path: `/gtw/auth/auth/legacy`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthAssistantEncryptedMessage
   * @summary Assistant: issue short-lived challenge JWT and return it encrypted to the profile public key
   * @request POST:/gtw/auth/auth/assistant/encrypted-message
   * @secure
   * @response `200` `ApiAssistantEncryptedMessageResponse` Encrypted challenge JWT (client decrypts with mnemonic-derived private key)
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `404` `void` Profile not found for public key
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authAssistantEncryptedMessage = (
    data: ApiAssistantPublicKeyDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiAssistantEncryptedMessageResponse, ApiBaseError>({
      path: `/gtw/auth/auth/assistant/encrypted-message`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthAssistantLoginDecryptedMessage
   * @summary Assistant: exchange verified challenge JWT for assistant access token
   * @request POST:/gtw/auth/auth/assistant/login-decrypted-message
   * @secure
   * @response `200` `ApiAssistantAuthResponse`
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Invalid or expired challenge JWT
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authAssistantLoginDecryptedMessage = (
    data: ApiAssistantLoginChallengeJwtDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiAssistantAuthResponse, ApiBaseError>({
      path: `/gtw/auth/auth/assistant/login-decrypted-message`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthGoogleVerifyCode
   * @summary Exchange Google authorization code for JWT tokens
   * @request POST:/gtw/auth/auth/google/verify/code
   * @secure
   * @response `200` `ApiAuthResponse` Returns access and refresh tokens after Google code exchange
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Invalid Google authorization code or failed to fetch profile
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authGoogleVerifyCode = (
    data: ApiGoogleVerifyCodeDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiAuthResponse, ApiBaseError>({
      path: `/gtw/auth/auth/google/verify/code`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthGoogleVerify
   * @summary Verify Google ID token and get JWT tokens
   * @request POST:/gtw/auth/auth/google/verify
   * @secure
   * @response `200` `ApiAuthResponse` Returns access and refresh tokens after Google verification
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Invalid Google ID token or failed to fetch profile
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authGoogleVerify = (data: ApiGoogleVerifyDto, params: RequestParams = {}) =>
    this.request<ApiAuthResponse, ApiBaseError>({
      path: `/gtw/auth/auth/google/verify`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthMarketingSettings
   * @summary Set marketing settings
   * @request POST:/gtw/auth/auth/marketing-settings
   * @secure
   * @response `200` `ApiSuccessResponse` Marketing settings set successfully
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authMarketingSettings = (
    data: ApiSetMarketingDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/auth/marketing-settings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthOnboardingCompleted
   * @summary Mark onboarding as completed for current user
   * @request POST:/gtw/auth/auth/onboarding-completed
   * @secure
   * @response `200` `ApiSuccessResponse` Onboarding marked as completed
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authOnboardingCompleted = (params: RequestParams = {}) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/auth/onboarding-completed`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthPushSettings
   * @summary Set mobile push notification settings
   * @request POST:/gtw/auth/auth/push-settings
   * @secure
   * @response `200` `ApiSuccessResponse` Push settings set successfully
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authPushSettings = (
    data: ApiSetPushSettingsDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/auth/push-settings`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthMe
   * @summary Get current user information
   * @request GET:/gtw/auth/auth/me
   * @secure
   * @response `200` `ApiCurrentUserResponse` Returns current user information
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authMe = (params: RequestParams = {}) =>
    this.request<ApiCurrentUserResponse, ApiBaseError>({
      path: `/gtw/auth/auth/me`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthUpdateUser
   * @summary Update user first name and last name
   * @request PUT:/gtw/auth/auth/me
   * @secure
   * @response `200` `ApiCurrentUserResponse` User information successfully updated
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authUpdateUser = (data: ApiUpdateUserDto, params: RequestParams = {}) =>
    this.request<ApiCurrentUserResponse, ApiBaseError>({
      path: `/gtw/auth/auth/me`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Auth
   * @name AuthFcmToken
   * @summary Set FCM token for current session
   * @request POST:/gtw/auth/auth/fcm-token
   * @secure
   * @response `200` `ApiSuccessResponse` FCM token successfully set for current session
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Invalid refresh token or session expired
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authFcmToken = (data: ApiUpdateFcmTokenDto, params: RequestParams = {}) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/auth/fcm-token`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Referral
   * @name ReferralApply
   * @summary Apply referral code for current user
   * @request POST:/gtw/auth/referral-codes/apply
   * @secure
   * @response `200` `ApiSuccessResponse` Referral code applied successfully
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  referralApply = (data: ApiApplyReferralCodeDto, params: RequestParams = {}) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/referral-codes/apply`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Referral
   * @name ReferralListCodes
   * @summary List referral codes created by current user
   * @request GET:/gtw/auth/referral-codes
   * @secure
   * @response `200` `(ApiReferralCodeResponse)[]` List of referral codes (code, createdAt, expiresAt, status, recipientEmail)
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  referralListCodes = (params: RequestParams = {}) =>
    this.request<ApiReferralCodeResponse[], ApiBaseError>({
      path: `/gtw/auth/referral-codes`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Referral
   * @name ReferralCreateCode
   * @summary Create a new referral code (quota checked in auth)
   * @request POST:/gtw/auth/referral-codes
   * @secure
   * @response `201` `ApiReferralCodeResponse` Referral code created
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  referralCreateCode = (params: RequestParams = {}) =>
    this.request<ApiReferralCodeResponse, ApiBaseError>({
      path: `/gtw/auth/referral-codes`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Referral
   * @name ReferralUpdateCode
   * @summary Update referral code (e.g. recipient email for Manage Referral)
   * @request PATCH:/gtw/auth/referral-codes/{codeId}
   * @secure
   * @response `200` `ApiReferralCodeResponse` Referral code updated
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  referralUpdateCode = (
    codeId: string,
    data: ApiUpdateReferralCodeDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiReferralCodeResponse, ApiBaseError>({
      path: `/gtw/auth/referral-codes/${codeId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Referral
   * @name ReferralSendCodeEmail
   * @summary Send referral code by email (rate limit enforced in owner-referral)
   * @request POST:/gtw/auth/referral-codes/{codeId}/send-email
   * @secure
   * @response `200` `ApiSuccessResponse` Email send initiated
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  referralSendCodeEmail = (
    codeId: string,
    data: ApiSendReferralCodeEmailDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/referral-codes/${codeId}/send-email`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Referral
   * @name ReferralCanRequestSystemCode
   * @summary Check if current user can request a system code
   * @request GET:/gtw/auth/referral-codes/system-code-request/can-request
   * @secure
   * @response `200` `ApiCanRequestSystemCodeResponse` Returns whether the user can request a system code
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  referralCanRequestSystemCode = (params: RequestParams = {}) =>
    this.request<ApiCanRequestSystemCodeResponse, ApiBaseError>({
      path: `/gtw/auth/referral-codes/system-code-request/can-request`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Referral
   * @name ReferralCreateSystemCodeRequest
   * @summary Create a system code request with questionnaire answers
   * @request POST:/gtw/auth/referral-codes/system-code-request
   * @secure
   * @response `201` `ApiSystemCodeRequestResponse` System code request created
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `401` `void` Unauthorized
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `409` `void` System code request already exists
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  referralCreateSystemCodeRequest = (
    data: ApiCreateSystemCodeRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiSystemCodeRequestResponse, ApiBaseError>({
      path: `/gtw/auth/referral-codes/system-code-request`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Get all scopes where tenantProfileId equals current user profileId (all child users)
   *
   * @tags Scopes
   * @name ScopeControllerFindAll
   * @summary Get all scopes for tenant user
   * @request GET:/gtw/auth/scopes
   * @secure
   * @response `200` `(ApiScopeResponse)[]` List of scopes successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scopeControllerFindAll = (params: RequestParams = {}) =>
    this.request<ApiScopeResponse[], ApiBaseError>({
      path: `/gtw/auth/scopes`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Create a scope directly without using invitation flow
   *
   * @tags Scopes
   * @name ScopeControllerCreate
   * @summary Create scope bypassing invitations
   * @request POST:/gtw/auth/scopes
   * @secure
   * @response `201` `void` Scope successfully created
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scopeControllerCreate = (
    data: ApiCreateScopeDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/auth/scopes`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * @description Get all tenant profiles
   *
   * @tags Scopes
   * @name ScopeControllerFindTenantProfiles
   * @summary Get tenant profiles for current user
   * @request GET:/gtw/auth/scopes/tenant
   * @secure
   * @response `200` `(ApiTenantProfileResponse)[]` List of tenant profiles successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scopeControllerFindTenantProfiles = (params: RequestParams = {}) =>
    this.request<ApiTenantProfileResponse[], ApiBaseError>({
      path: `/gtw/auth/scopes/tenant`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Scopes
   * @name ScopeControllerDelete
   * @summary Delete scope
   * @request DELETE:/gtw/auth/scopes/{scopeId}
   * @secure
   * @response `204` `void` Scope successfully deleted
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  scopeControllerDelete = (scopeId: number, params: RequestParams = {}) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/auth/scopes/${scopeId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Invitations
   * @name InvitationControllerFindAll
   * @summary Get list of invitations sent by current user
   * @request GET:/gtw/auth/invitations
   * @secure
   * @response `200` `(ApiInvitationResponse)[]` List of invitations successfully retrieved
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  invitationControllerFindAll = (
    query?: {
      /* Template custom: data-contract-jsdoc */
      scope?: "VFO" | "INTERWILL" | "REPOSITORY";
    },
    params: RequestParams = {},
  ) =>
    this.request<ApiInvitationResponse[], ApiBaseError>({
      path: `/gtw/auth/invitations`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Invitations
   * @name InvitationControllerCreateVfo
   * @summary Create VFO invitation
   * @request POST:/gtw/auth/invitations/vfo
   * @secure
   * @response `201` `ApiInvitationResponse` Invitation successfully created
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  invitationControllerCreateVfo = (
    data: ApiCreateInvitationDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiInvitationResponse, ApiBaseError>({
      path: `/gtw/auth/invitations/vfo`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Invitations
   * @name InvitationControllerCreateRepository
   * @summary Create REPOSITORY invitation
   * @request POST:/gtw/auth/invitations/repository
   * @secure
   * @response `201` `ApiInvitationResponse` Invitation successfully created
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  invitationControllerCreateRepository = (
    data: ApiCreateInvitationDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiInvitationResponse, ApiBaseError>({
      path: `/gtw/auth/invitations/repository`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Invitations
   * @name InvitationControllerValidateToken
   * @summary Validate invitation token
   * @request POST:/gtw/auth/invitations/validate
   * @secure
   * @response `200` `ApiSuccessResponse` Invitation token is valid
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  invitationControllerValidateToken = (
    data: ApiAcceptInvitationDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/invitations/validate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Invitations
   * @name InvitationControllerAccept
   * @summary Accept invitation
   * @request POST:/gtw/auth/invitations/accept
   * @secure
   * @response `200` `ApiSuccessResponse` Invitation successfully accepted
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  invitationControllerAccept = (
    data: ApiAcceptInvitationDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/invitations/accept`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Invitations
   * @name InvitationControllerResend
   * @summary Resend invitation
   * @request POST:/gtw/auth/invitations/{invitationId}/resend
   * @secure
   * @response `200` `ApiInvitationResponse` Invitation successfully resent
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  invitationControllerResend = (
    invitationId: string,
    params: RequestParams = {},
  ) =>
    this.request<ApiInvitationResponse, ApiBaseError>({
      path: `/gtw/auth/invitations/${invitationId}/resend`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Invitations
   * @name InvitationControllerDelete
   * @summary Delete invitation
   * @request DELETE:/gtw/auth/invitations/{invitationId}
   * @secure
   * @response `204` `void` Invitation successfully deleted
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  invitationControllerDelete = (
    invitationId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, ApiBaseError>({
      path: `/gtw/auth/invitations/${invitationId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Pin
   * @name AuthPinOprfEvaluate
   * @summary Evaluate blinded PIN using OPRF
   * @request POST:/gtw/auth/pin/oprf/evaluate
   * @secure
   * @response `200` `ApiPinOprfEvaluationResponse` Returns serialized OPRF evaluation
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authPinOprfEvaluate = (
    data: ApiPinOprfEvaluateDto,
    params: RequestParams = {},
  ) =>
    this.request<ApiPinOprfEvaluationResponse, ApiBaseError>({
      path: `/gtw/auth/pin/oprf/evaluate`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Pin
   * @name AuthPinSetup
   * @summary Store PIN verifier and encrypted payload for current session
   * @request POST:/gtw/auth/pin/setup
   * @secure
   * @response `200` `ApiSuccessResponse` PIN successfully configured for current session
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authPinSetup = (data: ApiPinSetupDto, params: RequestParams = {}) =>
    this.request<ApiSuccessResponse, ApiBaseError>({
      path: `/gtw/auth/pin/setup`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /* Template custom: procedure-call */
  /**
   * No description
   *
   * @tags Pin
   * @name AuthPinUnlock
   * @summary Unlock encrypted payload for current session using PIN verifier
   * @request POST:/gtw/auth/pin/unlock
   * @secure
   * @response `200` `ApiPinUnlockResponse` Returns encrypted payload after successful PIN verification
   * @response `400` `ApiErrorResponse` Bad Request
   * @response `403` `ApiErrorResponse` Forbidden
   * @response `429` `ApiErrorResponse` Too Many Requests
   * @response `500` `ApiErrorResponse` Internal Server Error
   * @response `504` `ApiErrorResponse` Gateway Timeout
   */
  authPinUnlock = (data: ApiPinUnlockDto, params: RequestParams = {}) =>
    this.request<ApiPinUnlockResponse, ApiBaseError>({
      path: `/gtw/auth/pin/unlock`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
